import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastComponent } from 'src/app/shared/toast/toast.component';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export enum ToastActions {
  ADD = 'add',
  UPDATE = 'update',
  UPLOAD = 'upload',
  DELETE = 'delete',
  ERROR = 'error'
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private readonly snackBar: MatSnackBar) {}

  private open(
    type: ToastType,
    title: string,
    message?: string,
    duration = 4000
  ) {
    this.snackBar.openFromComponent(ToastComponent, {
      data: { type, title, message },
      duration,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: 'custom-toast'
    });
  }

  showToast(action: ToastActions, context: string) {
    if (action === ToastActions.ERROR) {
      this.showError(context);
      return;
    }
    const actionMap: Record<string, string> = {
      [ToastActions.ADD]: 'added',
      [ToastActions.UPDATE]: 'updated',
      [ToastActions.UPLOAD]: 'uploaded',
      [ToastActions.DELETE]: 'deleted'
    };
    const verb = actionMap[action] ?? action;
    this.open('success', `${context} ${verb}`);
  }

  showError(message: string, title = 'Error') {
    this.open('error', title, message, 6000);
  }

  showWarning(message: string, title = 'Warning') {
    this.open('warning', title, message, 5000);
  }

  showInfo(message: string, title = 'Info') {
    this.open('info', title, message, 4000);
  }

  closeToast() {
    this.snackBar.dismiss();
  }
}
